export enum PlayerAdapterVideoFormat {
	HLS = 'hls',
	DASH = 'dash',
	MP4 = 'mp4',
	UNKNOWN = 'unknown'
}